/** @jsx jsx */
import { jsx } from 'theme-ui';


export const Container = (props) => (
  <div
    sx={{
      display: 'flex',
      flexFlow: 'column nowrap',
      justifyContent: 'center',
      '> div:last-child': {
        paddingBottom: '0',
      },
    }}
    {...props}
  />
);

export const DualHeadline = (props) => (
  <div
    sx={{
      lineHeight: '1',
      paddingBottom: '3rem',
      // '> span:first-child': {
      //   fontWeight: 700,
      // },
      letterSpacing: '1px',
      '> span:nth-of-type(2)': {
        color: 'PrimaryBrightBlue',
      },
    }}
    {...props}
  />
);

export const Headline = (props) => (
  <span
    sx={{
      display: 'block',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      fontSize: ['20px', '28px'],
    }}
    {...props}
  />
);
